// extracted by mini-css-extract-plugin
export var Page = "page-module--Page--2334e";
export var slideIn = "page-module--slide-in--bd121";
export var slideInFromRight = "page-module--slide-in-from-right--f8c50";